import { Card, Box, Skeleton, styled, IconButton, Icon } from '../../../base';

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.spacing(1),
}));

export const StyledCard = styled(Card)(({ theme }) => ({
    height: '400px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
}));

export const StyledCardHeader = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: 'none',
}));

export const StyledHeaderTitle = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.text.primary,
}));

export const StyledJobsIconWrapper = styled(IconButton)(({ theme }) => ({
    marginInlineEnd: theme.spacing(1),
    height: '55px',
    width: '55px',
    '&:disabled': {
        backgroundColor: theme.palette.background.mainBackground,
    },
}));

export const StyledJobsIcon = styled(Icon)(({ theme }) => ({
    color: theme.palette.secondary.main,
}));
